import './App.css';
import MainContainer from './containers/MainContainer';
import Layout from './layouts/MainLayout.jsx';

function App() {
  return (
    <Layout>
    <MainContainer />
    </Layout>
  );
}

export default App;